<template>
<div>
    <div class="full split-bottom">
        
        <div v-if="files != undefined && files.length > 0" class="full">
            <div class="header">
                <div class="label">Hochgeladene Dokumente</div>
            </div>
            <b-table class="documents" striped hover :borderless="true" :outlined="false" :items="files" :fields="fields">
                <template slot="link" slot-scope="row">
                    <a :href="row.item.url+'/api/file?id='+row.item.fileId+'&accessToken='+row.item.accessToken" target="_blank"><i class="fas fa-eye"></i></a>
                </template>
                <template slot="actions" slot-scope="row">
                    <div class="button small mright8" v-on:click="openFile(row)"><div class="label">Öffnen</div></div>
                    <div class="button small mright8" v-on:click="openEditModal(row)"><div class="label">Bearbeiten</div></div>
                    <div v-if="row.item.documentType !== 'CONTRACT' || !row.item.approved" class="button small" v-on:click="openDeleteModal(row)"><div class="label">Löschen</div></div>
                </template>
            </b-table>
        </div>
        <div class="full" v-else>
            <div class="header">
                <div class="label">Dokumente hochladen</div>
            </div>
            <div class="full">
                <div class="label">Keine Dokumente vorhanden, klicke auf das "+" um etwas hochzuladen!</div>
            </div>
            
            </div>
        </div>

    <b-modal ref="modal-createfile" no-close-on-backdrop no-close-on-esc centered @cancel="hideModal('modal-createfile')" :hide-header="true" :hide-footer="true">
        <div class="upload">
            <b-row>
                <b-col>
                    <div class="header">
                        <div class="label">Datei hochladen</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-createfile'); resetFile()">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <div v-if="previewPdf && pageCount > 1 && page > 1" @click="prevPage" class="previous fas fa-chevron-left" ></div>
                <b-col style="margin: 0px 35px;">
                    <div class="add">
                        <b-form-file @input="fileSelected()" style="display:none;" hidden id="file" accept="image/jpeg, image/png, application/pdf" v-model="employeeFile.upload" ref="fileInput" class="mb-2"></b-form-file>
                        <div v-if="uploading" class="loading">
                            <i class="fas fa-spinner"></i>
                        </div>
                        <div v-else-if="preview" style="width: 100%; height: 100%;">
                            <img id="imgPreview" class="preview" :src="previewSrc"/>
                            <div class="text-center" style="margin: 8px;">
                                <div class="button red" @click="resetFile">
                                    <div class="label">
                                        Foto löschen
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="previewPdf" style="width: 100%; height: 100%;">
                            <pdf 
                                style="width: calc(100% - 16px); margin: 8px;"
                                :src="previewPdfSrc"
                                @numPages="pageCountLoaded"
                                @num-pages="pageCountLoaded"
                                :page="page"
                                ></pdf>
                            <div class="text-center" style="margin: 8px;">
                                <div class="button red" @click="resetFile">
                                    <div class="label">
                                        PDF löschen
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="fa-stack" v-on:click.stop="selectFileForUpload()">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-plus fa-stack-2x"></i>
                        </div>
                    </div>
                </b-col>
                <div v-if="previewPdf && pageCount > 1 && page < pageCount" @click="nextPage" class="next fas fa-chevron-right"></div>
            </b-row>
            <b-row>
                <b-col>
                    <b-row>
                        <b-col cols="2">
                            <div class="param">
                                Name:
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="cd-input" style="margin-top:0px;" v-bind:class="{bottomline: employeeFile.name == undefined || employeeFile.name == ''}">
                                <input id="filename" v-model="employeeFile.name"/>
                            </div>
                        </b-col>
                        <b-col cols="2">
                            <div class="param">
                                Typ:
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="select-style" style="margin-right:35px;">
                                <select id="documenttype" v-model="employeeFile.documentType">
                                    <!--
                                    <option key="1" value="CONTRACT">
                                        Arbeitsvertrag
                                    </option>
                                    -->
                                    <option key="2" value="ID">
                                        Ausweis
                                    </option>
                                    <option key="3" value="DRIVERSLICENSE">
                                        Führerschein
                                    </option>
                                    <option key="4" value="REGISTRATION">
                                        Meldezettel
                                    </option>
                                    <option key="5" value="MISC">
                                        Sonstiges
                                    </option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <hr/>
                    <b-row style="margin-top:12px;">
                        <b-col>
                            <div class="mright35">
                            <div class="button green right" @click="createFile">
                                <div class="label">
                                    Speichern
                                </div>
                            </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal ref="modal-editfile" no-close-on-backdrop no-close-on-esc centered :hide-header="true" :hide-footer="true">
        <div class="upload">
            <b-row>
                <b-col>
                    <div class="header">
                        <div class="label">Datei bearbeiten</div>
                    </div>
                    <div class="close" v-on:click="hideModal('modal-editfile'); resetFile()">
                        <i class="fas fa-times"></i>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <div v-if="previewPdf && pageCount > 1 && page > 1" @click="prevPage" class="previous fas fa-chevron-left" ></div>
                <b-col style="margin: 0px 35px;">
                    <div class="add">
                        <div v-if="preview" style="width: 100%; height: 100%;">
                            <img id="imgPreview" class="preview" :src="employeeFile.url"/>
                        </div>
                        <div v-else-if="previewPdf" style="width: 100%; height: 100%;">
                            <pdf 
                                style="width: calc(100% - 16px); margin: 8px;"
                                :src="employeeFile.url"
                                @numPages="pageCountLoaded"
                                @num-pages="pageCountLoaded"
                                :page="page"
                                ></pdf>
                        </div>
                    </div>
                </b-col>
                <div v-if="previewPdf && pageCount > 1 && page < pageCount" @click="nextPage" class="next fas fa-chevron-right"></div>
            </b-row>
            <b-row>
                <b-col>
                    <b-row v-if="employeeFile.documentType != 'CONTRACT'">
                        <b-col cols="2">
                            <div class="param">
                                Name:
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <input id="filename" v-model="employeeFile.name"/>
                        </b-col>
                        <b-col cols="2">
                            <div class="param">
                                Typ:
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <div class="select-style" style="margin-right:35px;">
                                <select id="documenttype" v-model="employeeFile.documentType">
                                    <!--
                                    <option key="1" value="CONTRACT">
                                        Arbeitsvertrag
                                    </option>
                                    -->
                                    <option key="2" value="ID">
                                        Ausweis
                                    </option>
                                    <option key="3" value="DRIVERSLICENSE">
                                        Führerschein
                                    </option>
                                    <option key="4" value="REGISTRATION">
                                        Meldezettel
                                    </option>
                                    <option key="5" value="MISC">
                                        Sonstiges
                                    </option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col cols="2">
                            <div class="param">
                                Name:
                            </div>
                        </b-col>
                        <b-col cols="9">
                            <div class="cd-input" style="margin-top:0px;" v-bind:class="{bottomline: employeeFile.name == undefined || employeeFile.name == ''}">
                                <input id="filename" v-model="employeeFile.name"/>
                            </div>
                        </b-col>
                    </b-row>
                    <hr/>
                    <b-row style="margin-top:12px;">
                        <b-col>
                            <div class="mright35">
                            <div class="button green right" @click="editFile()">
                                <div class="label">
                                    Speichern
                                </div>
                            </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </b-modal>
    <b-modal ref="modal-deletefile" no-close-on-backdrop no-close-on-esc centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">Datei löschen</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1">
                Sind Sie sicher dass Sie die Datei löschen wollen?
            </b-row>
            <b-row v-if="fileerror" class="my-1">
                Fehler beim Löschen der Datei.
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button red right" @click="hideModal('modal-deletefile')">
                <div class="label">
                    Abbrechen
                </div>
            </div>
            <div class="button green right" @click="deleteFile()">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-deletecontractfile" no-close-on-backdrop no-close-on-esc centered>
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">Vertragsdokument löschen</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1">
                Sie sind im Begriff ein Dokument zu löschen, welches einem Arbeitsvertrag zugewiesen ist. Wenn das Dokument bereits bestätigt wurde muss ein neu hochgeladenes Dokument für den jeweiligen Arbeitsvertrag erneut bestätigt werden. Sind Sie sicher dass Sie die Datei löschen wollen?
            </b-row>
            <b-row v-if="fileerror" class="my-1">
                Fehler beim Löschen der Datei.
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button red right" @click="hideModal('modal-deletecontractfile')">
                <div class="label">
                    Abbrechen
                </div>
            </div>
            <div class="button green right" @click="deleteFile()">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-modal ref="modal-upload-error" centered title="Fehler">
        <template slot="modal-header">
            <div class="error-modal">
                <div class="headerlabel">Fehler</div>
            </div>
        </template>
        <b-container fluid>
            <b-row class="my-1">
                Um den Datei Upload durchzuführen bitte {{ uploadErrorMessage }}!
            </b-row>
        </b-container>
        <template slot="modal-footer">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <div class="button green right" @click="closeErrorModal()">
                <div class="label">
                    OK
                </div>
            </div>
        </template>
    </b-modal>
    <b-form-file @input="fileSelected(true)" style="display:none;" hidden id="file-outer" accept="image/jpeg, image/png, application/pdf" v-model="employeeFile.upload" ref="fileInput" class="mb-2"></b-form-file>
</div>
</template>

<script>

import pdf from 'vue-pdf'

export default {
    name: 'employeedocuments',
    props: ["employeeId"],
    components: {
        pdf
    },
    computed: {

    },
    watch: {
        employeeId: function(val, oldVal){
            this.resetFile();
            this.refresh();
        }
    },
    data() {
        return {
            fileMap: {},
            files: [],
            fields: [{
                key: "icon",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd fileIcon'
            },{
                key: "name",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "documentType",
                label: "Dokument",
                formatter: "documentType",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "creationDate",
                label: "Datum",
                formatter: "creationDate",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "actions",
                label: "",
                sortable: false,
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }],
            employeeFile: {
                name: "",
                documentType: "UNDEFINED",
                upload: null,
            },
            backupFile: {
                name: "",
                documentType: "UNDEFINED",
                upload: null,
            },
            fileId: "",
            docType: "",
            currentrow: {},
            uploading: false,
            uploadErrorMessage: '',
            preview: false,
            previewSrc: "",
            previewPdf: false,
            previewPdfSrc: "",
            pageCount: 0,
            page: 1,
            fileerror: false
        }
    },
    created: function () {

        this.refresh();
    },
    // methods that implement data logic.
    methods: {
        refresh: function () {
            let view = this;
            view.loadFiles()
                .then(response => {
                    view.updateFiles(response.data);
                }).catch(function (error) {
                    console.log(error)
                });
        },
        fileUploadDataError(){
            if(!this.employeeFile.upload) return "Datei auswählen";
            else if(!this.employeeFile.name) return "Namen wählen";
            else if(!this.employeeFile.documentType || this.employeeFile.documentType === 'UNDEFINED') return "Dokumenten Typ auswählen";
            return null;
        },
        selectFileForUpload(){
            var elem = document.getElementById('file');
            elem.click();
        },
        selectFileForUploadFromParent(){
            var elem = document.getElementById('file-outer');
            elem.click();
        },
        fileSelected(openModal = false){
            var view = this;
            if(this.employeeFile.upload){
                console.log('File selected, openModal: ' + openModal);
                if(openModal) this.showModal('modal-createfile');
                var reader = new FileReader();
                reader.onload = function (e){
                    if(view.employeeFile.upload.type == "application/pdf"){
                        view.preview = false;
                        view.previewPdf = true;
                        view.previewPdfSrc = e.target.result;
                    }else{
                        view.previewPdf = false;
                        view.preview = true;
                        view.previewSrc = e.target.result;   
                    }
                };
                reader.readAsDataURL(this.employeeFile.upload);
            }
        },
        pageCountLoaded(event){
            this.pageCount = event;
            this.$forceUpdate();
        },
        prevPage(){
            if(this.page > 1) this.page = this.page - 1;
        },
        nextPage(){
            if(this.page < this.pageCount) this.page = this.page + 1;
        },
        resetFile(frontendOnly = false){
            this.previewSrc = '';
            this.preview = false;
            this.previewPdfSrc = '';
            this.previewPdf = false;
            this.uploading = false;
            if(!frontendOnly){
                this.employeeFile = {
                    upload: null,
                    name: "",
                    documentType: 'UNDEFINED'
                }
            }
        },
        openFile(row){
            let url = row.item.url+'/api/file?id='+row.item.fileId+'&accessToken='+row.item.accessToken;
            window.open(url, '_blank');
        },
        createFile: function (evt) {
            evt.preventDefault();
            this.uploadErrorMessage = this.fileUploadDataError();
            if(this.uploadErrorMessage == null){
                this.fileerror = false;
                let view = this;
                let url = '/api/sec/employeefile/upload';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile/upload');

                let formData = new FormData();
                formData.append("employeeId", this.$props.employeeId);
                formData.append("name", this.employeeFile.name);
                formData.append("documentType", this.employeeFile.documentType);
                formData.append('file', this.employeeFile.upload);

                this.uploading = true;
                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: formData
                }).then(response => {
                    let file = response.data.data;
                    view.fileMap[file.id] = file;
                    view.files.push(file);
                    view.uploading = false;
                    view.resetFile(false);
                    view.hideModal('modal-createfile');
                }).catch(function (error) {
                    view.fileerror = true;
                    view.uploading = false;
                    //view.resetFile(false);
                    console.log(error)
                })
            }else{
                this.backupFile = this.employeeFile;
                this.showModal('modal-upload-error');
            }
        },
        closeErrorModal(){
            this.hideModal('modal-upload-error'); 
            this.employeeFile = this.backupFile;
        },
        openEditModal: function (row) {
            this.currentrow = row;
            let url = '/api/employeefile/content?fileId='+row.item.fileId+'&accessToken='+row.item.accessToken+'&url='+row.item.url;
            let fileType = row.item.fileType;
            if(fileType == 'application/pdf'){
                this.previewPdf = true;
                this.preview = false;
            }else{
                this.previewPdf = false;
                this.preview = true;
            }
            this.employeeFile = {
                name: row.item.name,
                documentType: row.item.documentType,
                fileType: row.item.fileType,
                url: url
            };
            this.fileId = row.item.id;
            this.showModal('modal-editfile');
        },
        editFile: function () {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeefile';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');

            let payload = {
                id: this.fileId,
                name: this.employeeFile.name,
                documentType: this.employeeFile.documentType,
                updateFields: ["name", "documentType"]
            }

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.currentrow.item.name = view.employeeFile.name;
                view.currentrow.item.documentType = view.employeeFile.documentType;
                view.hideModal('modal-editfile');
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            })

        },
        openDeleteModal: function (row) {
            this.currentrow = row;
            this.fileId = row.item.id;
            this.docType = row.item.documentType;
            if(this.docType == 'CONTRACT'){
                this.showModal('modal-deletecontractfile');
            }else{
                this.showModal('modal-deletefile');
            }
        },
        deleteFile: function () {
            this.fileerror = false;
            let view = this;
            let url = '/api/sec/employeefile';

            url = this.$helpers.appendParam("id", this.fileId, url, '/api/sec/employeefile');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                const index = this.files.findIndex(file => file.id === view.fileId) // find the filesinessunit index 
                if(view.docType == 'CONTRACT'){
                    view.$emit('contract-deleted', view.fileId);
                }
                if (~index) {
                    view.files.splice(index, 1);
                }
                view.hideModal('modal-deletefile');
                view.hideModal('modal-deletecontractfile');
            }).catch(function (error) {
                view.fileerror = true;
                console.log(error)
            })
        },
        loadFiles: function () {
            let view = this;
            let url = '/api/sec/employeefile';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeefile');
            url = this.$helpers.appendParam("employeeId", this.$props.employeeId, url, '/api/sec/employeefile');

            return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        updateFiles: function (data) {
            let overviewA = [];
            let fileM = {};
            var i;
            for (i = 0; i < data.length; i++) {

                fileM[data[i].id] = data[i];
                overviewA.push(data[i]);
            }
            this.fileMap = fileM;
            this.files = overviewA;
        },
        hideModal(ref) {
            this.fileerror = false;
            this.fileId = "";
            this.employeeFile = {
                    name: "",
                    documentType: "ID",
                    upload: null,
                },
                this.currentrow = {};

            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },
        creationDate(str){
            return this.$helpers.extractDateString(str, "DD.MM.YYYY | HH:mm");
        },
        documentType(key){
            switch(key){
                case 'CONTRACT':
                    return 'Arbeitsvertrag';
                    break;
                case 'ID':
                    return 'Ausweis';
                    break;
                case 'DRIVERSLICENSE':
                    return 'Führerschein';
                    break;
                case 'REGISTRATION':
                    return 'Meldezettel';
                    break;
                case 'MISC':
                    return 'Sonstiges';
                    break;
                default:
                    return 'Sonstiges';
            }
        }
    }
}
</script>

<!-- Add "scoped" attrifilete to limit CSS to this component only -->

<style scoped>

</style>
